module.exports = __webpack_public_path__ + "img/galery-dcu30-2.84ee10f6.png";